import { Modal } from '@/components/Modal'
import { modalId } from '../hooks/useController'
import { Content } from './Content'

interface Props {
  roadSegments: string[]
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content roadSegments={props.roadSegments} />
    </Modal>
  )
}
